import React from "react";
import Logo from "../components/Logo";
import Navigation from "../components/Navigation";
import { useTranslation } from 'react-i18next';


const Home = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Logo />
      <Navigation />
      <div className="accueil">

      <h1>{t("discover")}</h1>

      <div className="bulle left">
        <h3>
        {t("innovation_title")}
        </h3>
        <br />
        <p>
        {t("innovation_description")}
        </p>
      </div>

      <div className="bulle right">
        <h3>
        {t("simplicity_title")}
        </h3>
        <br />
        <p>
        {t("simplicity_description")}
        </p>
      </div>


      <div className="bulle left">
        <h3>
        {t("customization_title")}
        </h3>
        <br />
        <p>
        {t("customization_description")}
        </p>
      </div>

      

      <div className="bulle right">
        <h3>
        {t("practical_advantages_title")}
        </h3>
        <br />
        <p>
        {t("practical_advantages_description")}
        </p>
      </div>
      </div>

    </div>
  );
};

export default Home;
